<template>
  <div class="match-invite-page page">
    <!-- 顶部 -->
    <page-top></page-top>
    <!-- 头部 -->
    <Header @chooseTab="getTab" currentIndex="1"></Header>
    <!-- 主体 -->
    <main class="main">
      <section class="breadcrumb-plate">
        <div class="label">我的位置：</div>
        <breadcrumb />
      </section>

      <section class="w">
        <div class="c-top">
          <tabbar
            :tabData="tabList"
            :code="categoryId"
            :seccode="seccode"
            :subcode="subcode"
            @changeSecTab="changeSecTab"
          ></tabbar>
        </div>
      </section>
      <section class="w">
        <div>
          <span class="c-title">{{ currentCategory?.categoryName }}</span>
          <span class="english-name">{{ currentCategory?.englishName }}</span>
        </div>
      </section>
      <section class="content w">
        <div class="c-left">
          <!-- 内容 -->
          <div class="list">
            <div class="item" v-for="(item, index) in newsList" :key="index">
              <div class="img-wrap">
                <img class="img" :src="item.cover" alt="" />
              </div>
              <div class="txt">{{ item.articleName }}</div>
            </div>
          </div>
          <!-- 页码 -->
          <div
            class="m-bot"
            v-if="newsList.length > 0 && pageCount >= pageSize"
          >
            <el-pagination
              background
              layout="prev, pager, next"
              prev-text="上一页"
              next-text="下一页"
              :page-size="pageSize"
              :total="pageCount"
              @current-change="changePageClick"
            >
            </el-pagination>
          </div>
        </div>
      </section>
    </main>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import pageTop from '@/components/common/pageTop.vue'
import Header from '@/components/train/header.vue'
import Footer from '@/components/train/footer.vue'
import Breadcrumb from '@/components/common/breadcrumb'
import Tabbar from '@/components/list/tabbar.vue'

import { getArticlePage } from '@/api/home/home.js'
import { getNavItemByCode } from '@/api/common/common.js'
export default {
  name: 'Policy',
  components: { pageTop, Header, Footer, Breadcrumb, Tabbar },
  data() {
    return {
      pageSize: 9, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: [],
      tabTitle: '新闻中心',
      newsList: [],
      article: '',
      pageType: '', //1 文章内容，2 文章列表
      categoryId: '',
      tabcode: '',
      seccode: '',
      subcode: '',
      currentCategory: {
        categoryName: '',
        englishName: ''
      }
    }
  },
  methods: {
    //统一获取数据
    fetchData() {
      if (!this.tabcode) return
      getNavItemByCode(this.tabcode).then((res) => {
        if (!res.data) return
        //侧边栏列表
        this.tabList = res.data[0]

        if (this.tabList.categoryCode == this.categoryId) {
          this.currentCategory = this.tabList
        }
        if (this.currentCategory.categoryName == '') {
          let attr = this.tabList.list.filter((p) => {
            if (p.categoryCode == this.categoryId) {
              console.log('categoryName', p.categoryName)
              return p
            }
          })
          if (attr.length) {
            this.currentCategory = attr[0]
          }
        }
      })

      //获取文章列表
      this.getArticlePage()
    },
    //获取header组件的点击事件
    getTab(data) {
      if (data && typeof data == 'string') {
        this.$router.push('/' + data)
      }
    },
    //获取文章列表
    getArticlePage(page = 1) {
      getArticlePage({
        page: page,
        limit: this.pageSize,
        categoryCode: this.categoryId
      }).then((res) => {
        console.log(res.data)
        if (!res.data) return
        this.newsList = res.data.list
        this.pageCount = Number(res.data.count)
      })
    },
    //切换页面
    changePageClick(page) {
      this.getArticlePage(page)
    },
    //点击改变栏目
    changeSecTab(item, tab) {
      this.currentCategory = item
      console.log('item', this.currentCategory)
      console.log('tab', tab)
      let url =
        '?categoryId=' +
        item.categoryCode +
        '&linkType=' +
        item.linkType +
        '&tabcode=' +
        this.tabcode
      url = tab ? url + '&seccode=' + tab : url

      this.seccode = tab //二级标题
      this.categoryId = item.categoryCode //当前标题
      this.subcode = item.categoryCode //三级标题
      this.pageType = item.linkType
      if (this.tabList.list && this.tabList.list.length > 0) {
        const targetItem = this.tabList.list.find(
          (item) => item.categoryCode == this.categoryId
        )

        if (this.categoryId == this.seccode && targetItem?.list?.length) {
          item = item.list[0]
          this.seccode = targetItem.categoryCode
          this.subcode = targetItem.list[0].categoryCode
          this.categoryId = targetItem.list[0].categoryCode
        }
      }

      // 展示富文本
      //链接类型：1/文章详情,2/单图列表,3/图文列表,4/文本列表,5/切换详情列表
      if (item.linkType == 1) {
        url = '/train/article' + url + '&id=' + item.linkUrl
      }
      if (item.linkType == 2) {
        url = '/train/singleImage' + url
      }
      if (item.linkType == 3) {
        url = '/train/imageText' + url
      }
      if (item.linkType == 4) {
        url = '/train/textList' + url
      }
      if (item.linkType == 5) {
        url = '/train/tabList' + url
      }

      this.$router.push({
        path: url
      })
    }
  },
  created() {
    this.pageType = this.$route.query?.linkType
    this.categoryId = this.$route.query?.categoryId
    this.tabcode = this.$route.query?.tabcode
    this.seccode = this.$route.query?.seccode
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-breadcrumb__inner.is-link,
::v-deep .el-breadcrumb__inner.is-link:hover {
  color: #fff;
}
::v-deep .el-breadcrumb__separator,
::v-deep .el-breadcrumb__separator:hover {
  color: #fff;
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner,
::v-deep.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: #fff;
}

.match-invite-page {
  .main {
    flex: 1;
    padding-bottom: 80px;
    background-color: #ffffff;
    margin-top: 60px;

    .breadcrumb-plate {
      background: linear-gradient(to top, #347cd0 0%, #62a3f0 100%);
      color: #fff;

      display: flex;
      align-items: center;
      padding: 16px 0;
      padding-left: 180px;

      .label {
        line-height: 1;
        font-size: 14px;
      }
    }

    .c-title {
      font-size: 30px;
      padding-left: 17px;
      border-left: 3px solid rgb(12, 108, 228);
      font-weight: 700;
    }
    .english-name {
      color: rgb(153, 153, 153);
      margin-left: 10px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      margin-top: 30px;
      margin-bottom: 100px;

      .c-top {
        display: flex;
        justify-content: center;
      }

      .c-left {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        padding-bottom: 70px;

        .list {
          display: flex;
          flex-wrap: wrap;

          .item {
            display: flex;
            flex-direction: column;
            flex: 0 0 30%;
            box-shadow: 0 2px 12px 0 rgba(32, 32, 32, 0.1);
            margin: 10px;
            margin-right: 20px;
            padding: 20px;

            .img-wrap {
              cursor: pointer;
              width: 100%; /* 容器的宽度 */
              height: 100%; /* 容器的高度 */
              max-height: 250px;
              display: flex;
              justify-content: center; /* 水平居中 */
              align-items: center; /* 垂直居中 */
              overflow: hidden; /* 超出部分隐藏 */
              img {
                max-width: 100%; /* 最大宽度不超过容器的宽度 */
                // max-height: 100%; /* 最大高度不超过容器的高度 */
                object-fit: contain; /* 保持图片的宽高比 */
              }
            }
            .txt {
              margin-top: 20px;
              text-align: center;
              font-size: 15px;
            }
          }
        }
        .m-bot {
          margin-top: 24px;
          margin-bottom: 24px;

          .el-pagination {
            display: flex;
            justify-content: center;

            ::v-deep .btn-prev {
              width: 100px;
              height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            ::v-deep .btn-prev:hover:enabled {
              color: #409eff;
            }

            ::v-deep .number {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            ::v-deep .more {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            ::v-deep .btn-next {
              width: 100px;
              height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            ::v-deep .btn-next:hover:enabled {
              color: #409eff;
            }

            ::v-deep .active {
              color: #fff;
              background-color: #409eff;
            }
          }
        }
      }
      .c-right {
        flex: 1;
        margin-left: 20px;
        img {
          width: 570px;
          height: 377px;
        }
      }
    }
  }
}
</style>
